import { render } from "./NewBack.vue?vue&type=template&id=0d009b4c"
import script from "./NewBack.vue?vue&type=script&lang=js"
export * from "./NewBack.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hitenradadiya/Front/shiv_mfg_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__